export class Servicio {
  public id: number;
  public titulo: string;
  public texto: string;
  public imagen: string;
  public link: string;

  public imagenes: [];

  constructor() { }
}
